import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Input, Pipe, PipeTransform, AfterViewInit, EventEmitter, Output } from '@angular/core';
import { trigger, state, style, transition, animate, query, group, stagger } from '@angular/animations';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { CustomerService } from '../../services/customer.service';
import { OrdersService } from '../../services/orders.service';

import { buildDashboardThemeVars } from '../../shared/dashboard-widget-theme';
@Component({
	selector: 'app-customer-carts',
	templateUrl: './customer-carts.component.html',
	styleUrls: ['./customer-carts.component.scss'],
	animations: [
		trigger('flipState', [
			state('active', style({
				transform: 'rotate3d(0, 1, 0, 180deg)',
			})),
			state('inactive', style({
				transform: 'rotateY(0)'
			})),
			state('orderlookup', style({
				transform: 'rotateY(179deg)'
			})),
			transition('active => inactive', animate('500ms ease-out')),
			transition('inactive => active', animate('500ms ease-in')),
			transition('inactive => orderlookup', animate('500ms ease-out')),
			transition('orderlookup => inactive', animate('500ms ease-in')),
		]),
		trigger('openClose', [
			state(':enter', style({ height: '*' })),
			state(':leave', style({ height: '0px' })),
			transition('false <=> true', animate(500))
		]),
		trigger('filterAnimation', [
			transition(':enter, * => 0, * => -1', []),
			transition(':increment', [
				query(':enter', [
					style({ opacity: 0, width: 0 }),
					stagger(50, [
						animate('300ms ease-out', style({ opacity: 1, width: '*' })),
					]),
				], { optional: true })
			]),
			transition(':decrement', [
				query(':leave', [
					stagger(50, [
						animate('300ms ease-out', style({ opacity: 0, width: 0 })),
					]),
				])
			]),
		]),
		trigger('grow', [ // Note the trigger name
			transition(':enter', [
				// :enter is alias to 'void => *'
				style({ height: '0', width: '0' }),
				animate(200, style({ height: '*', width: '*' })),
				animate('200ms', style({ opacity: 1 })),
			]),
			transition(':leave', [
				// :leave is alias to '* => void'
				animate(100, style({ height: 0, width: 0 })),
				animate('100ms', style({ opacity: 0 }))
			])
		]),
	]
})
export class CustomerCartsComponent implements OnInit {

	get themeVars(): Record<string, string> {
		return buildDashboardThemeVars('cw', 'danger');
	}

	private _cartBucketsCache: { key: string; value: any[] } = { key: '', value: [] };
	get cartBuckets(): any[] {
		const key = `${this.cartagebuckets?.[1]?.length ?? 'x'}:${this.cartagebuckets?.[2]?.length ?? 'x'}:${this.cartagebuckets?.[3]?.length ?? 'x'}:${this.cartsettings?.settings_ageone}:${this.cartsettings?.settings_agetwo}`;
		if (this._cartBucketsCache.key !== key) {
			const buckets: any[] = [];
			if (this.cartagebuckets?.[1]) {
				buckets.push({ label: 'New', count: this.cartagebuckets[1].length, data: this.cartagebuckets[1] });
			}
			if (this.cartagebuckets?.[2]) {
				buckets.push({ label: (this.cartsettings?.settings_ageone || '') + ' Day', count: this.cartagebuckets[2].length, data: this.cartagebuckets[2] });
			}
			if (this.cartagebuckets?.[3]) {
				buckets.push({ label: (this.cartsettings?.settings_agetwo || '') + ' Day', count: this.cartagebuckets[3].length, data: this.cartagebuckets[3] });
			}
			this._cartBucketsCache = { key, value: buckets };
		}
		return this._cartBucketsCache.value;
	}

	onCartBucket(bucket: any): void {
		const label = bucket?.label ? `Customer Carts (${bucket.label})` : 'Customer Carts';
		this.toggleFlip(bucket.data, label);
	}


	@Input() flip = 'inactive';
	@Output() viewData = new EventEmitter < any > ();
	viewing: any = false;

	private _data: any = false;
	@Input() set data(val: any) {
		if (val) {
			this._data = val;
			this.processCartData(val);
		}
	}
	get data(): any {
		return this._data;
	}
	title = 'Customer Carts';

	currentcarts: any = [];
	cartagebuckets: any = [];
	cartsettings: any = [];
	@ViewChild('cartDetailsRef') cartDetails: ElementRef;

	cartdetails: any = [];
	constructor(private ordersService: OrdersService, private customerService: CustomerService, private modalService: NgbModal) {}

	ngOnInit(): void {
		if (!this._data) {
			this.customerService.getCurrentCarts().subscribe(async(results: any) => {
				this._data = results.data;
				this.currentcarts = results.data;
				this.cartsettings = {
					settings_ageone: results.settings_ageone,
					settings_agetwo: results.settings_agetwo
				};
				this.processCartData(results.data);
			});
		}
	}

	processCartData(carts: any[]): void {
		if (!Array.isArray(carts)) return;
		this.cartagebuckets[3] = carts.filter( c => {
			return c.agegroup == '3'
		});
		this.cartagebuckets[2] = carts.filter( c => {
			return c.agegroup == '2'
		});
		this.cartagebuckets[1] = carts.filter( c => {
			return c.agegroup == '1'
		});
	}

	toggleFlip(data: any, title: string) {

		if (!data) {
			this.flip = 'inactive';
		} else {
			this.flip = (this.flip == 'active') ? 'inactive' : 'active';
		}

		if (this.flip == 'active') {
			this.viewing = data;
			this.title = title || 'Customer Carts';
			const dashboard_data = { data: data, title: 'Customer Carts' }
			this.viewData.emit(dashboard_data);
		} else {
			this.viewData.emit(false);
		}
	}

	viewCart(debtor: any) {

		const data = {
			customerno: debtor.debtorno,
			branchcode: debtor.branchcode,
			cartcard: true
		}
		this.customerService.getCartDetails(data).subscribe(results => {
			this.cartdetails = Array.isArray(results) ? results : (results?.data || []);
			this.modalService.open(this.cartDetails, { ariaLabelledBy: 'modal-title', size: 'lg' }).result.then((result) => {

			}, (reason) => {
				this.cartdetails = false;
			});
		})
	}
}
